
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-file",
  props: {
    fileTitle: String,
    createdAt: String,
    fileType: String,
    canManage: {
      type: Boolean,
      default: false
    },
    canPublish: {
      type: Boolean,
      default: false
    },
    indexingStatus: {
      type: String,
      default: ""
    }
  },
  emits: ["open", "rename", "delete", "publish"],
  computed: {
    indexingStatusLabel(): string {
      switch (String(this.indexingStatus || "").toLowerCase()) {
        case "pending":
          return "Pending";
        case "processing":
          return "Indexing";
        case "indexed":
          return "Ready";
        case "failed":
          return "Failed";
        default:
          return "";
      }
    },
    indexingStatusClass(): string {
      switch (String(this.indexingStatus || "").toLowerCase()) {
        case "pending":
          return "badge-light-warning";
        case "processing":
          return "badge-light-primary";
        case "indexed":
          return "badge-light-success";
        case "failed":
          return "badge-light-danger";
        default:
          return "badge-light";
      }
    }
  }
});
